const basePath = '/acceptance-documents';

export class AcceptanceDocumentPath {
  static index() {
    return basePath;
  }

  static termsUpdate() {
    return '/terms-update';
  }
}
